export default __webpack_public_path__ + "9ae72a60e03874af7d69b46d50b94b61.png";